<template>
  <div class="header2">
    <div class="date">
      <div class="calendar-buttons">
        <div class="flex">
          <div class="arrow arrow-left" @click="changeOffset(-7)"><i class="fas fa-chevron-left"></i></div>
          <div class="arrow arrow-right" @click="changeOffset(7)"><i class="fas fa-chevron-right"></i></div>
        </div>
      </div>
      <div class="heading-medium ml-3">
        {{ first_day.format('YYYY') }} {{ first_day.format('MMMM') }} {{ first_day.format('D') }} - {{ last_day.format('D') }}
      </div>
    </div>
    <div v-for="date in value.dates"
         class="day heading-small"
         :class="{'today' : today.format('DD') === date.format('DD')}"
    >
      {{ date.format('ddd') }} <br> {{ date.format('D') }}
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import Arrangement from '../agenda/Arrangement.vue'


export default {
  props: {
    value: {},
  },
  components: {
    Arrangement,
  },
  created() {
    this.generateDates()

    this.$root.$on('Header2::today', () => this.setOffset(this.value.default_offset))
  },
  data() {
    return {
      today: moment(),
    }
  },
  watch: {
    'value.offset': function() {
      this.$root.$emit('Agenda::reload')
    }
  },
  computed: {
    first_day() {
      return this.value.dates[0] || moment()
    },
    last_day() {
      return this.value.dates[this.value.dates.length - 1] || moment()
    }
  },
  methods: {
    generateDates() {
      this.value.dates = [];
      for (let i = this.value.offset; i < this.value.offset + this.value.days_to_show; i++) {
        this.value.dates.push(moment().add(i, 'd'))
      }
    },
    setOffset(c) {
      this.value.offset = c
      this.generateDates()
    },
    changeOffset(c) {
      this.value.offset += c
      this.generateDates()
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/views/agenda-v2/header2.vue